import React from 'react';
import PropTypes from 'prop-types';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { colors } from '../../constants/styleConstants';

const OpenNewIcon = ({ color }) => {
  return (
    <OpenInNewIcon style={{ fill: color }} />
  )
};

OpenNewIcon.propTypes = {
  color: PropTypes.string,
}

OpenNewIcon.defaultProps = {
  color: colors.blue,
}

export default OpenNewIcon;